import type {
  UserRecord,
  WeeklyScheduleRecordMap,
  MembershipRecord,
  AccountRecord
} from '@libs/data-access/entities'
import type { ReduxState } from '@spa/redux/ReduxState'
import { createStructuredSelector } from 'reselect'
import { getCurrentAccount } from 'snap-redux/modules/accounts/selectors'
import { getMembershipsByUserId } from 'snap-redux/modules/memberships/selectors'
import { getCurrentUserId } from 'snap-redux/modules/users/selectors'
import { getAllUniqueWeeklyschedules } from 'snap-redux/modules/weeklyschedules/selectors'

const account = (state: ReduxState): AccountRecord => getCurrentAccount(state)

const weeklyschedules = (state: ReduxState): WeeklyScheduleRecordMap =>
  getAllUniqueWeeklyschedules(state)

export const baseStructuredSelector = createStructuredSelector({
  account,
  currentUserId: getCurrentUserId,
  weeklyschedules
})

const currentUser = (state: ReduxState, currentUserId: number): UserRecord =>
  currentUserId && state.users.getIn(['data', currentUserId])
const currentMembership = (
  state: ReduxState,
  currentUserId: number
): MembershipRecord => getMembershipsByUserId(state, currentUserId).first()

export const currentUserSelector = createStructuredSelector({
  currentUser,
  currentMembership
})
